import {actionTypeSetPageInfo} from "../reducers/pageInfo/type";

export function setPageInfo(pageInfo) {
  return {
    type: actionTypeSetPageInfo,
    payload: pageInfo
  }
}